<ng-container *ngTemplateOutlet="template"></ng-container>
<wct-error-message [errorMessage]="errorMessage">
